export const ARREGLO_WITHOUT_ORDER = 'ARREGLO_WITHOUT_ORDER'
export const ARREGLO_WITH_ORDER = 'ARREGLO_WITH_ORDER'
